module.exports = __webpack_public_path__ + "img/imgSpa.2c49fd10.jpg";